import useIsNLplan from '../../../common/src/hooks/useIsNLPlan';
import {
  flowIdShortCheckupCompanyBE,
  flowIdShortCheckupCompanyNL,
} from '../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../flows/src/hooks/useFlowsResetState';
import { CompanyRegistration } from '../../../parties/src/types';

const useStartShortCheckupCompanyFlow = () => {
  const { isNL } = useIsNLplan();
  const { initFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();

  return async (
    uuid?: string,
    inputUrl?: string,
    partyId?: string,
    quoteId?: string,
    companyRegistration?: CompanyRegistration,
  ) => {
    reset();
    await initFlow({
      flowId: isNL ? flowIdShortCheckupCompanyNL : flowIdShortCheckupCompanyBE,
      payload: {
        party_id: partyId,
        quote_id: quoteId,
        company_registration: companyRegistration,
      },
      inputUrl,
      outputUrl: `/sales-conversation/company-checkup/finalize`,
      sessionId: uuid,
      shouldComplete: false,
    });
  };
};

export default useStartShortCheckupCompanyFlow;
